import { createSelector } from '@reduxjs/toolkit';
import BigNumber from 'bignumber.js';
import { RootState } from '../app/rootReducer';
import { summarizeBalanceInUsd } from '../wallet/walletService';

const balanceSelector = (state: RootState) => state.wallet.balances;
const currencySelector = (state: RootState) => state.currency;

export const balanceSummarySelector = createSelector(currencySelector, balanceSelector, (currency, balances): {
  coin: BigNumber,
  share: BigNumber,
  lending: BigNumber,
} => {
  if (currency.coins.pricing.length === 0 || !balances || balances.length === 0) {
    return null;
  }
  // also filter discontinued coins
  const filteredBalances = balances.filter(balance => !balance.coin.discontinued);
  return summarizeBalanceInUsd(filteredBalances, currency.coins.pricing);
});
